<template>
  <div class="location_list">
    <div v-if="all_loc_history.length < 1">
      <h1 style="text-align: center">
        {{ translate('no_data') }}
      </h1>
    </div>

    <div v-else class="response_table">
      <table>
        <thead>
        <tr>
          <th scope="col" class="pointer" style="width: 20px"></th>
          <th scope="col" class="pointer" @click="change_filter('country')"
              :class="{'selected' : filter_type === 'country'}">
            {{ translate('location.country') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'country'}"></i>
          </th>
          <th scope="col" class="pointer" @click="change_filter('city')" :class="{'selected' : filter_type === 'city'}">
            {{ translate('location.city') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'city'}"></i>
          </th>
          <th scope="col" class="pointer">
            {{ translate('location.period') }}
          </th>
          <th
              scope="col"
              class="pointer"
              @click="change_filter('duration')"
              :class="{'selected' : filter_type === 'duration'}"
          >
            {{ translate('location.duration') }}
            <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'duration'}"></i>
          </th>

          <th scope="col" class="pointer w30"></th>
          <th scope="col" class="pointer w30"></th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(location,key) in all_loc"
          :key="key"
          @click.prevent="show_info(location)"
          :class="location.show ? 'checked' : ''"
          class="location"
        >
          <td class="flag">
            <CountryFlags :country="location.country"/>
          </td>
          <td :data-label="translate('location.country')">
            {{ location.country }}
          </td>
          <td :data-label="translate('location.city')">
            {{ location.city ? location.city : "" }}
          </td>
          <td :data-label="translate('location.period')">
            {{ location.period ? location.period[0] + ' - ' + location.period[1] : '' }}
          </td>
          <td :data-label="translate('location.duration')">
            {{ convert_duration(location.duration) }}
          </td>
          <td class="w30">
            <span
                v-if="location.parking"
                class="mdi mdi-anchor"
            />
          </td>
          <td class="w30">
            <span
              v-if="location.show"
              @click.stop.prevent="hide_info(location)"
              class="mdi mdi-close"
            />
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import CountryFlags from "components/UIComponents/CountryFlags/CountryFlags.vue";

export default {
  name: 'LocationList',
  components: {
    CountryFlags
  },
  props: ['all_loc_history'],

  data() {
    return {
      filter_type: 'id',
      filter_asc: 'desc',
    }
  },

  computed: {
    all_loc() {
      let list = [...this.all_loc_history]
      list.sort(this.compareNumbers)
      return list
    },
  },

  watch:{
    all_loc_history(){
      this.filter_type = ""
      this.filter_asc = ""
    }
  },

  created() {

  },
  methods: {
    show_info(item) {
      if (item.id) this.$emit("show_info", item.id)
    },
    hide_info(item) {
      this.$emit("hide_info", item.id)
    },
    convert_duration(duration) {
      let minutes = 0
      let hours = Math.round((duration / (60 * 60)));
      if (hours < 5) {
        minutes = Math.round((duration / 60));
        return minutes + " min."
      } else if (hours > 100) {
        let days = Math.round(((duration / 60) / 60) / 24);
        hours = Math.round(((duration / 60) % 60) % 24);
        return days + " days, " + hours + " hours"
      }
      return hours + " hours"
    },

  }
}

</script>
<style lang="scss" scoped>
.location_list{
  height: 100%;
  .response_table{
    width: 100%;
    padding: 5px;
    tr{
      height: 27px;
      cursor: pointer;
      &.checked{
        background-color: #e2ecdc;
      }
      &.location{
        .flag{
          width: 20px;
          .phoca-flag{
            position: relative;
            width: 20px;
            height: 20px;
            margin: 0;
            box-shadow: none;
            border: none;
          }
        }

        &:hover{
          background-color: #ddd;
        }
      }
    }
    .w30{
      width: 30px;
      font-size: 16px;
      line-height: 100%;
    }
  }
}

</style>
